import { Component } from 'react';


export default class AppErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Island City News failed to render.', error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="Section-Header" role="alert">
          <h2>Island City News couldn&apos;t finish loading.</h2>
          <p>Refresh the page to try again. If it continues, check the local console.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
